import { getDeviceLocale } from '@unistocks/shared/utils/device-utils';
import { I18n } from 'i18n-js';

export const i18n = new I18n(undefined, {
  defaultLocale: getDeviceLocale(),
  defaultSeparator: '::'
});
